module.exports = __webpack_public_path__ + "img/apple.5cd457f9.png";